import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const RangeComponent = ({ range = {} }) => {
  const [value, setValue] = useState(range.value || 0);
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = range.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = range;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = range;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = range;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = range;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = range;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (range.backgroundImage && range.backgroundImage.startsWith("./")) {
        const imageName = range.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(range.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [range.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        range.labelbackgroundImagelabel &&
        range.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = range.labelbackgroundImagelabel.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(range.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [range.labelbackgroundImagelabel, files]);

  const handleChange = (newValue) => {
    setValue(newValue);
    if (typeof range.onChange === "function") {
      range.onChange(newValue);
    }
  };

  const focusedStyles =
    isDivFocused && range.pseudoClass === "focus"
      ? {
          // width: range.focusedwidth || range.width || "fit-content",
          // height: range.focusedheight || range.height || "auto",

          padding: range.focusedpadding || range.padding || "0",
          paddingTop:
            range.focusedpaddingTop || range.focusedpadding || "0",
          paddingRight:
            range.focusedpaddingRight ||
            range.focusedpadding ||
            "0",
          paddingBottom:
            range.focusedpaddingBottom ||
            range.focusedpadding ||
            "0",
          paddingLeft:
            range.focusedpaddingLeft || range.focusedpadding || "0",
          margin: range.focusedmargin || range.margin || "0px",
          marginTop:
            range.focusedmarginTop || range.focusedmargin || "0px",
          marginRight:
            range.focusedmarginRight ||
            range.focusedmargin ||
            "10px",
          marginBottom:
            range.focusedmarginBottom ||
            range.focusedmargin ||
            "0px",
          marginLeft:
            range.focusedmarginLeft || range.focusedmargin || "10px",

          borderTop:
            range.focusedborderTop ||
            range.focusedborder ||
            range.border ||
            "none",
          borderRight:
            range.focusedborderRight ||
            range.focusedborder ||
            range.border ||
            "none",
          borderBottom:
            range.focusedborderBottom ||
            range.focusedborder ||
            range.border ||
            "none",
          borderLeft:
            range.focusedborderLeft ||
            range.focusedborder ||
            range.border ||
            "none",
          borderSapcing:
            range.focusedborderSpacing ||
            range.borderSpacing ||
            "0px",
          borderCollapse:
            range.focusedborderCollapse ||
            range.borderCollapse ||
            "0px",
          borderRadius:
            range.focusedborderRadius || range.borderRadius || "0",
          outline: range.focusedoutline || range.outline || "none",

          position:
            range.focusedposition || range.position || "relative",
          top: range.focusedtop || range.top || "auto",
          right: range.focusedright || range.right || "auto",
          bottom: range.focusedbottom || range.bottom || "auto",
          left: range.focusedleft || range.left || "auto",
          zIndex: range.focusedzIndex || range.zIndex || "auto",

          color: range.focusedcolor || range.color || "#000000",
          backgroundColor:
            range.focusedbackgroundColor ||
            range.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (range.focusedbackgroundImage) {
              if (range.focusedbackgroundImage.startsWith("./")) {
                const imageName = range.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${range.focusedbackgroundImage})`;
            }
            if (range.backgroundImage) {
              if (range.backgroundImage.startsWith("./")) {
                const imageName = range.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${range.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            range.focusedbackgroundPosition ||
            range.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            range.focusedbackgroundSize ||
            range.backgroundSize ||
            "auto",
          backgroundRepeat:
            range.focusedbackgroundRepeat ||
            range.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            range.focusedbackgroundAttachment ||
            range.backgroundAttachment ||
            "scroll",

          boxShadow:
            range.focusedboxShadow || range.boxShadow || "none",
          opacity: range.focusedOpacity || range.opacity || 1,
          display: range.focuseddisplay || range.display || "inline",

          cursor: range.focusedcursor || range.cursor || "default",
          transform:
            range.focusedtransform || range.transform || `scale(${range.scale})`,
          transition:
            range.focusedtransition || range.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && range.pseudoClass === "hover"
      ? {
          // width: range.hoveredwidth || range.width || "fit-content",
          // height: range.hoveredheight || range.height || "auto",

          padding: range.hoveredpadding || range.padding || "0",
          paddingTop:
            range.hoveredpaddingTop || range.hoveredpadding || "0",
          paddingRight:
            range.hoveredpaddingRight ||
            range.hoveredpadding ||
            "0",
          paddingBottom:
            range.hoveredpaddingBottom ||
            range.hoveredpadding ||
            "0",
          paddingLeft:
            range.hoveredpaddingLeft || range.hoveredpadding || "0",
          margin: range.hoveredmargin || range.margin || "0px",
          marginTop:
            range.hoveredmarginTop || range.hoveredmargin || "0px",
          marginRight:
            range.hoveredmarginRight ||
            range.hoveredmargin ||
            "10px",
          marginBottom:
            range.hoveredmarginBottom ||
            range.hoveredmargin ||
            "0px",
          marginLeft:
            range.hoveredmarginLeft || range.hoveredmargin || "10px",

          borderTop:
            range.hoveredborderTop ||
            range.hoveredborder ||
            range.border ||
            "none",
          borderRight:
            range.hoveredborderRight ||
            range.hoveredborder ||
            range.border ||
            "none",
          borderBottom:
            range.hoveredborderBottom ||
            range.hoveredborder ||
            range.border ||
            "none",
          borderLeft:
            range.hoveredborderLeft ||
            range.hoveredborder ||
            range.border ||
            "none",
          borderSapcing:
            range.hoveredborderSpacing ||
            range.borderSpacing ||
            "0px",
          borderCollapse:
            range.hoveredborderCollapse ||
            range.borderCollapse ||
            "0px",
          borderRadius:
            range.hoveredborderRadius || range.borderRadius || "0",
          outline: range.hoveredoutline || range.outline || "none",

          position:
            range.hoveredposition || range.position || "relative",
          top: range.hoveredtop || range.top || "auto",
          right: range.hoveredright || range.right || "auto",
          bottom: range.hoveredbottom || range.bottom || "auto",
          left: range.hoveredleft || range.left || "auto",
          zIndex: range.hoveredzIndex || range.zIndex || "auto",

          color: range.hoveredcolor || range.color || "#000000",
          backgroundColor:
            range.hoveredbackgroundColor ||
            range.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (range.hoveredbackgroundImage) {
              if (range.hoveredbackgroundImage.startsWith("./")) {
                const imageName = range.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${range.hoveredbackgroundImage})`;
            }
            if (range.backgroundImage) {
              if (range.backgroundImage.startsWith("./")) {
                const imageName = range.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${range.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            range.hoveredbackgroundPosition ||
            range.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            range.hoveredbackgroundSize ||
            range.backgroundSize ||
            "auto",
          backgroundRepeat:
            range.hoveredbackgroundRepeat ||
            range.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            range.hoveredbackgroundAttachment ||
            range.backgroundAttachment ||
            "scroll",

          boxShadow:
            range.hoveredboxShadow || range.boxShadow || "none",
          opacity: range.hoveredOpacity || range.opacity || 1,
          display: range.hovereddisplay || range.display || "inline",

          cursor: range.hoveredcursor || range.cursor || "default",
          transform:
            range.hoveredtransform || range.transform || `scale(${range.scale})`,
          transition:
            range.hoveredtransition || range.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && range.pseudoClass === "active"
      ? {
          // width: range.activatedwidth || range.width || "fit-content",
          // height: range.activatedheight || range.height || "auto",

          padding: range.activatedpadding || range.padding || "0",
          paddingTop:
            range.activatedpaddingTop || range.activatedpadding || "0",
          paddingRight:
            range.activatedpaddingRight ||
            range.activatedpadding ||
            "0",
          paddingBottom:
            range.activatedpaddingBottom ||
            range.activatedpadding ||
            "0",
          paddingLeft:
            range.activatedpaddingLeft || range.activatedpadding || "0",
          margin: range.activatedmargin || range.margin || "0px",
          marginTop:
            range.activatedmarginTop || range.activatedmargin || "0px",
          marginRight:
            range.activatedmarginRight ||
            range.activatedmargin ||
            "10px",
          marginBottom:
            range.activatedmarginBottom ||
            range.activatedmargin ||
            "0px",
          marginLeft:
            range.activatedmarginLeft || range.activatedmargin || "10px",

          borderTop:
            range.activatedborderTop ||
            range.activatedborder ||
            range.border ||
            "none",
          borderRight:
            range.activatedborderRight ||
            range.activatedborder ||
            range.border ||
            "none",
          borderBottom:
            range.activatedborderBottom ||
            range.activatedborder ||
            range.border ||
            "none",
          borderLeft:
            range.activatedborderLeft ||
            range.activatedborder ||
            range.border ||
            "none",
          borderSapcing:
            range.activatedborderSpacing ||
            range.borderSpacing ||
            "0px",
          borderCollapse:
            range.activatedborderCollapse ||
            range.borderCollapse ||
            "0px",
          borderRadius:
            range.activatedborderRadius || range.borderRadius || "0",
          outline: range.activatedoutline || range.outline || "none",

          position:
            range.activatedposition || range.position || "relative",
          top: range.activatedtop || range.top || "auto",
          right: range.activatedright || range.right || "auto",
          bottom: range.activatedbottom || range.bottom || "auto",
          left: range.activatedleft || range.left || "auto",
          zIndex: range.activatedzIndex || range.zIndex || "auto",

          color: range.activatedcolor || range.color || "#000000",
          backgroundColor:
            range.activatedbackgroundColor ||
            range.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (range.activatedbackgroundImage) {
              if (range.activatedbackgroundImage.startsWith("./")) {
                const imageName = range.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${range.activatedbackgroundImage})`;
            }
            if (range.backgroundImage) {
              if (range.backgroundImage.startsWith("./")) {
                const imageName = range.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${range.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            range.activatedbackgroundPosition ||
            range.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            range.activatedbackgroundSize ||
            range.backgroundSize ||
            "auto",
          backgroundRepeat:
            range.activatedbackgroundRepeat ||
            range.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            range.activatedbackgroundAttachment ||
            range.backgroundAttachment ||
            "scroll",

          boxShadow:
            range.activatedboxShadow || range.boxShadow || "none",
          opacity: range.activatedOpacity || range.opacity || 1,
          display: range.activateddisplay || range.display || "inline",

          cursor: range.activatedcursor || range.cursor || "default",
          transform:
            range.activatedtransform || range.transform || `scale(${range.scale})`,
          transition:
            range.activatedtransition || range.transition || "none",
        }
      : {};

  const inputStyle = {
    width: range.width || "fit-content",
    height: range.height || "auto",

    margin: range.margin || "0px",
    marginTop: range.marginTop || range.margin || "0",
    marginRight: range.marginRight || range.margin || "10px",
    marginBottom: range.marginBottom || range.margin || "0",
    marginLeft: range.marginLeft || range.margin || "10px",
    padding: range.padding || "0px",
    paddingTop: range.paddingTop || range.padding || "0",
    paddingRight: range.paddingRight || range.padding || "0",
    paddingBottom: range.paddingBottom || range.padding || "0",
    paddingLeft: range.paddingLeft || range.padding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : range.borderTop || range.border || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : range.borderRight || range.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : range.borderBottom || range.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : range.borderLeft || range.border || "none",

    borderSapcing: range.borderSpacing || "0px",
    borderCollapse: range.borderCollapse || "0px",
    borderRadius: range.borderRadius || "0",
    outline: range.outline || "none",

    position: range.position || "static",
    top: range.top || "auto",
    right: range.right || "auto",
    bottom: range.bottom || "auto",
    left: range.left || "auto",
    zIndex: range.zIndex || "auto",

    color: range.color || "#000000",
    backgroundColor: range.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      range.focusedbackgroundPosition || range.backgroundPosition || "0% 0%",
    backgroundSize:
      range.focusedbackgroundSize || range.backgroundSize || "auto",
    backgroundRepeat:
      range.focusedbackgroundRepeat || range.backgroundRepeat || "repeat",
    backgroundAttachment:
      range.focusedbackgroundAttachment ||
      range.backgroundAttachment ||
      "scroll",

    opacity: range.opacity || "1",
    display: range.display || "inline",
    cursor: range.cursor || "auto",

    transform: range.transform || `scale(${range.scale})`,
    transition: range.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: range.labelmargin || "0px",
    marginTop: range.labelmarginTop || range.labelmargin || "0",
    marginRight: range.labelmarginRight || range.labelmargin || "0px",
    marginBottom: range.labelmarginBottom || range.labelmargin || "0",
    marginLeft: range.labelmarginLeft || range.labelmargin || "0",
    padding: range.labelpadding || "0px",
    paddingTop: range.labelpaddingTop || range.labelpadding || "0",
    paddingRight: range.labelpaddingRight || range.labelpadding || "0",
    paddingBottom: range.labelpaddingBottom || range.labelpadding || "0",
    paddingLeft: range.labelpaddingLeft || range.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : range.labelborderTop || range.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : range.labelborderRight || range.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : range.labelborderBottom || range.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : range.labelborderLeft || range.labelborder || "none",

    borderSapcing: range.labelborderSpacing || "0px",
    borderCollapse: range.labelborderCollapse || "0px",
    borderRadius: range.labelborderRadius || "0",
    outline: range.labeloutline || "none",

    position: range.labelposition || "static",
    top: range.labeltop || "auto",
    right: range.labelright || "auto",
    bottom: range.labelbottom || "auto",
    left: range.labelleft || "auto",
    zIndex: range.labelzIndex || "auto",

    color: range.labelcolor || "#000000",
    backgroundColor: range.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      range.labelbackgroundPosition || range.labelbackgroundPosition || "0% 0%",
    backgroundSize:
      range.labelbackgroundSize || range.labelbackgroundSize || "auto",
    backgroundRepeat:
      range.labelbackgroundRepeat || range.labelbackgroundRepeat || "repeat",
    backgroundAttachment:
      range.labelbackgroundAttachment ||
      range.labelbackgroundAttachment ||
      "scroll",

    fontSize: range.labelfontSize || "inherit",
    fontFamily: range.labelfontFamily || "inherit",
    fontWeight: range.labelfontWeight || "normal",
    fontStyle: range.labelfontStyle || "normal",
    fontVariant: range.labelfontVariant || "normal",
    lineHeight: range.labellineHeight || "normal",
    textAlign: range.labeltextAlign || "left",
    textDecoration: range.labeltextDecoration || "none",
    textTransform: range.labeltextTransform || "none",
    textShadow: range.labeltextShadow || "none",
    verticalAlign: range.labelverticalAlign || "baseline",
    letterSpacing: range.labelletterSpacing || "normal",
    wordSpacing: range.labelwordSpacing || "normal",
    textIndent: range.labeltextIndent || "0",
    whiteSpace: range.labelwhiteSpace || "normal",
    textOverflow: range.labeltextOverflow || "clip",
    direction: range.labeldirection || "ltr",
    unicodeBidi: range.labelunicodeBidi || "normal",
    writingMode: range.labelwritingMode || "horizontal-tb",

    opacity: range.labelopacity || "1",
    display: range.display || "inline",
    cursor: range.cursor || "auto",

    transform: range.transform || "none",
    transition: range.transition || "none",
  };

  return (
    <>
      <label style={labelStyle}>{range.label || "Range Input"}</label>
      <input
        type="range"
        id="x"
        min={range.minValue}
        max={range.maxValue}
        step={range.stepValue}
        value={value}
        disabled={range.disabled || false}
        style={inputStyle}
        onChange={(e) => handleChange(e.target.value)}
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
      />
      <output name="Output" htmlFor="x" style={labelStyle}>
        {value}
      </output>
    </>
  );
};

export default RangeComponent;
